
import sha1 from 'object-hash';

import {cookies, CookKey} from './cookies';

// 32-character hex pattern
const idPattern = /^[a-f0-9]{32}$/;

export const getLocalId = (): string => {
	const curr = cookies.get(CookKey.LocalId);
	if (curr && isValidId(curr)) {
		return curr;
	}

	const next = sha1({seed: Math.random()}).slice(0, 32);
	cookies.set(CookKey.LocalId, next, {expires: 365});
	return next;
};

export const isValidId = (id?: string): boolean => {
	if (id && id.match(idPattern)) {
		return true;
	}
	return false;
};
